export default __webpack_public_path__ + "static/media/question_mark_img.1b355092.svg";